export const PIN_TYPES = {
  regular: 'regular',
  regularOutsideGeo: 'regularOutsideGeo',
} as const;

export const PIN_EXTENDED_TYPES = {
  active: 'active',
  favorite: 'favorite',
  viewed: 'viewed',
  withBalloon: 'withBalloon',
  withCount: 'withCount',
  glow: 'glow',
} as const;

export type PinType = keyof typeof PIN_TYPES;
export type PinExtendedType = keyof typeof PIN_EXTENDED_TYPES;
export type PinExtendedTypes = Set<PinExtendedType>;

export type PinConfig = {
  radius: number;
  fillColor: string;
  textColor: string;
  borderColor: string;
  borderWidth: number;
  count?: string;
  withShadow?: boolean;
  glowRadius: number;
};
